import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DepartmentComponent } from './components/department/department.component';
import { AdddepartmentComponent } from './components/department/adddepartment/adddepartment.component';
import { CompanyComponent } from './components/company/company.component';
import { AddcompanyComponent } from './components/company/addcompany/addcompany.component';
import { BonustypeComponent } from './components/bonustype/bonustype.component';
import { AddbonustypeComponent } from './components/bonustype/addbonustype/addbonustype.component';
import { AddassettypeComponent } from './components/assettype/addassettype/addassettype.component';
import { AssettypeComponent } from './components/assettype/assettype.component';
import { AddallowanceComponent } from './components/allowance/addallowance/addallowance.component';
import { AllowanceComponent } from './components/allowance/allowance.component';
import { AddbranchComponent } from './components/branch/addbranch/addbranch.component';
import { BranchComponent } from './components/branch/branch.component';
import { DeductionComponent } from './components/deduction/deduction.component';
import { AdddeductionComponent } from './components/deduction/adddeduction/adddeduction.component';
import { DesignationComponent } from './components/designation/designation.component';
import { AdddesignationComponent } from './components/designation/adddesignation/adddesignation.component';
import { EmptypeComponent } from './components/emptype/emptype.component';
import { AddemptypeComponent } from './components/emptype/addemptype/addemptype.component';
import { ExpensetypeComponent } from './components/expensetype/expensetype.component';
import { AddexpensetypeComponent } from './components/expensetype/addexpensetype/addexpensetype.component';
import { GenderComponent } from './components/gender/gender.component';
import { AddgenderComponent } from './components/gender/addgender/addgender.component';
import { GradeComponent } from './components/grade/grade.component';
import { AddgradeComponent } from './components/grade/addgrade/addgrade.component';
import { IncidenttypeComponent } from './components/incidenttype/incidenttype.component';
import { AddincidenttypeComponent } from './components/incidenttype/addincidenttype/addincidenttype.component';
import { LeavetypeComponent } from './components/leavetype/leavetype.component';
import { AddleavetypeComponent } from './components/leavetype/addleavetype/addleavetype.component';
import { LoantypeComponent } from './components/loantype/loantype.component';
import { AddloantypeComponent } from './components/loantype/addloantype/addloantype.component';
import { LocationComponent } from './components/location/location.component';
import { AddlocationComponent } from './components/location/addlocation/addlocation.component';
import { MaritalstatusComponent } from './components/maritalstatus/maritalstatus.component';
import { AddmaritalstatusComponent } from './components/maritalstatus/addmaritalstatus/addmaritalstatus.component';
import { MemotypeComponent } from './components/memotype/memotype.component';
import { AddmemotypeComponent } from './components/memotype/addmemotype/addmemotype.component';
import { SkillsComponent } from './components/skills/skills.component';
import { AddskillsComponent } from './components/skills/addskills/addskills.component';
import { RelievetypeComponent } from './components/relievetype/relievetype.component';
import { AddrelievetypeComponent } from './components/relievetype/addrelievetype/addrelievetype.component';
import { RelationshipComponent } from './components/relationship/relationship.component';
import { AddrelationshipComponent } from './components/relationship/addrelationship/addrelationship.component';
import { ReimbursetypeComponent } from './components/reimbursetype/reimbursetype.component';
import { AddreimbursetypeComponent } from './components/reimbursetype/addreimbursetype/addreimbursetype.component';
import { PayrolegrpComponent } from './components/payrolegrp/payrolegrp.component';
import { AddpayrolegrpComponent } from './components/payrolegrp/addpayrolegrp/addpayrolegrp.component';
import { AddpaymodeComponent } from './components/paymode/addpaymode/addpaymode.component';
import { PaymodeComponent } from './components/paymode/paymode.component';
import { AddovertimetypeComponent } from './components/overtimetype/addovertimetype/addovertimetype.component';
import { OvertimetypeComponent } from './components/overtimetype/overtimetype.component';
import { UserroleComponent } from './components/userrole/userrole.component';
import { AdduserroleComponent } from './components/userrole/adduserrole/adduserrole.component';
import { UserComponent } from './components/user/user.component';
import { AdduserComponent } from './components/user/adduser/adduser.component';
import { AssetComponent } from './components/asset/asset.component';
import { AddassetComponent } from './components/asset/addasset/addasset.component';
import { HolidaysComponent } from './components/holidays/holidays.component';
import { AddholidaysComponent } from './components/holidays/addholidays/addholidays.component';
import { EmpComponent } from './components/emp/emp.component';
import { AddempComponent } from './components/emp/addemp/addemp.component';
import { ExpenseComponent } from './components/expense/expense.component';
import { AddexpenseComponent } from './components/expense/addexpense/addexpense.component';
import { LeaveComponent } from './components/leave/leave.component';
import { AddleaveComponent } from './components/leave/addleave/addleave.component';
import { IncidentComponent } from './components/incident/incident.component';
import { AddincidentComponent } from './components/incident/addincident/addincident.component';


import { LoginComponent } from './login/login.component';
import { ReligionComponent } from './components/religion/religion.component';
import { AddreligionComponent } from './components/religion/addreligion/addreligion.component';
import { SponserComponent } from './components/sponser/sponser.component';
import { AddsponserComponent } from './components/sponser/addsponser/addsponser.component';
import { ContracttypeComponent } from './components/contracttype/contracttype.component';
import { AddcontracttypeComponent } from './components/contracttype/addcontracttype/addcontracttype.component';
import { CategoryComponent } from './components/category/category.component';
import { AddcategoryComponent } from './components/category/addcategory/addcategory.component';
import { PaytypeComponent } from './components/paytype/paytype.component';
import { AddpaytypeComponent } from './components/paytype/addpaytype/addpaytype.component';
import { WpsgroupComponent } from './components/wpsgroup/wpsgroup.component';
import { AddwpsgroupComponent } from './components/wpsgroup/addwpsgroup/addwpsgroup.component';
import { BankComponent } from './components/bank/bank.component';
import { AddbankComponent } from './components/bank/addbank/addbank.component';
import { AccomtypeComponent } from './components/accomtype/accomtype.component';
import { AddaccomtypeComponent } from './components/accomtype/addaccomtype/addaccomtype.component';
import { LeavepolicyComponent } from './components/leavepolicy/leavepolicy.component';
import { AddleavepolicyComponent } from './components/leavepolicy/addleavepolicy/addleavepolicy.component';
import { StatusComponent } from './components/status/status.component';
import { AddstatusComponent } from './components/status/addstatus/addstatus.component';
import { PendingChangesGuard } from './components/PendingChangesGuard ';
import { SalutionComponent } from './components/salution/salution.component';
import { AddsalutionComponent } from './components/salution/addsalution/addsalution.component';
import { HiresourceComponent } from './components/hiresource/hiresource.component';
import { AddhiresourceComponent } from './components/hiresource/addhiresource/addhiresource.component';
import { DoctypeComponent } from './components/doctype/doctype.component';
import { AdddoctypeComponent } from './components/doctype/adddoctype/adddoctype.component';
import { TestComponent } from './components/test/test.component';
import { TestmComponent } from './testm/testm.component';
import { BonusComponent } from './components/bonus/bonus.component';
import { AddBonusComponent } from './components/bonus/addbonus/addbonus.component';
import { ReimburseComponent } from './components/reimburse/reimburse.component';
import { AddreimburseComponent } from './components/reimburse/addreimburse/addreimburse.component';
import { MemoComponent } from './components/memo/memo.component';
import { AddmemoComponent } from './components/memo/addmemo/addmemo.component';

import { AddempnewComponent } from './components/emp/addempnew/addempnew.component';
import { AddempviewComponent } from './components/emp/addempview/addempview.component';

import { TrainingComponent } from './components/training/training.component';
import { AddtrainingComponent } from './components/training/addtraining/addtraining.component';
import { PayadvComponent } from './components/payadv/payadv.component';
import { AddpayadvComponent } from './components/payadv/addpayadv/addpayadv.component';
import { TransferComponent } from './components/transfer/transfer.component';
import { AddtransferComponent } from './components/transfer/addtransfer/addtransfer.component';
import { OvertimeComponent } from './components/overtime/overtime.component';
import { AddovertimeComponent } from './components/overtime/addovertime/addovertime.component';
import { LoanComponent } from './components/loan/loan.component';
import { AddloanComponent } from './components/loan/addloan/addloan.component';
import { PayrollComponent } from './components/payroll/payroll.component';
import { AddpayrollComponent } from './components/payroll/addpayroll/addpayroll.component';
import { AnnualleaveComponent } from './components/annualleave/annualleave.component';
import { AddannualleaveComponent } from './components/annualleave/addannualleave/addannualleave.component';
import { LeavesalaryComponent } from './components/leavesalary/leavesalary.component';
import { AddleavesalaryComponent } from './components/leavesalary/addleavesalary/addleavesalary.component';
import { PayadjComponent } from './components/payadj/payadj.component';
import { AddpayadjComponent } from './components/payadj/addpayadj/addpayadj.component';
import { ApprovalsComponent } from './components/approvals/approvals.component';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportsummaryComponent } from './components/reports/reportsummary/reportsummary.component';
import { BankbranchComponent } from './components/bankbranch/bankbranch.component';
import { AddbankbranchComponent } from './components/bankbranch/addbankbranch/addbankbranch.component';
import { AlerttypeComponent } from './components/alerttype/alerttype.component';
import { AddalerttypeComponent } from './components/alerttype/addalerttype/addalerttype.component';
import { SettingsComponent } from './components/settings/settings.component';
import { CurrencyComponent } from './components/currency/currency.component';
import { AddcurrencyComponent } from './components/currency/addcurrency/addcurrency.component';
import { ExpensepolicyComponent } from './components/expensepolicy/expensepolicy.component';
import { AddexpensepolicyComponent } from './components/expensepolicy/addexpensepolicy/addexpensepolicy.component';
import { ScheduletemplateComponent } from './components/scheduletemplate/scheduletemplate.component';
import { AddscheduletemplateComponent } from './components/scheduletemplate/addscheduletemplate/addscheduletemplate.component';
import { PtaxmainComponent } from './components/ptaxmain/ptaxmain.component';
import { AddptaxmainComponent } from './components/ptaxmain/addptaxmain/addptaxmain.component';
import { ReportemployeesummaryComponent } from './components/reports/reportemployeesummary/reportemployeesummary.component';
import { ActivitylogreportComponent } from './components/reports/activitylogreport/activitylogreport.component';
import { LeavereportComponent } from './components/reports/leavereport/leavereport.component';
import { AssetreportComponent } from './components/reports/assetreport/assetreport.component';
import { TrainingreportComponent } from './components/reports/trainingreport/trainingreport.component';
import { OvertimereportComponent } from './components/reports/overtimereport/overtimereport.component';
import { PayrollsummaryreportComponent } from './components/reports/payrollsummaryreport/payrollsummaryreport.component';
import { EmployeepayreportComponent } from './components/reports/employeepayreport/employeepayreport.component';
import { PayadvreportComponent } from './components/reports/payadvreport/payadvreport.component';
import { NavigationmenuComponent } from './components/navigationmenu/navigationmenu.component';
import { TranspaymodeComponent } from './components/transpaymode/transpaymode.component';
import { AddtranspaymodeComponent } from './components/transpaymode/addtranspaymode/addtranspaymode.component';
import { FinetypeComponent } from './components/finetype/finetype.component';
import { AddfinetypeComponent } from './components/finetype/addfinetype/addfinetype.component';
import { FineComponent } from './components/fine/fine.component';
import { AddfineComponent } from './components/fine/addfine/addfine.component';
import { PromotionComponent } from './components/promotion/promotion.component';
import { AddpromotionComponent } from './components/promotion/addpromotion/addpromotion.component';
import { DocumentexpiryreportComponent } from './components/documentexpiryreport/documentexpiryreport.component';
import { EmployeesalaryreportComponent } from './components/employeesalaryreport/employeesalaryreport.component';
import { LoansummaryreportComponent } from './components/reports/loansummaryreport/loansummaryreport.component';
import { LoanoutstandingsummaryreportComponent } from './components/reports/loanoutstandingsummaryreport/loanoutstandingsummaryreport.component';
import { CalendarviewComponent } from './components/grid/calendarview/calendarview.component';
import { RequesttypeComponent } from './components/requesttype/requesttype.component';
import { AddrequesttypeComponent } from './components/requesttype/addrequesttype/addrequesttype.component';
import { OtherrequestComponent } from './components/otherrequest/otherrequest.component';
import { AddotherrequestComponent } from './components/otherrequest/addotherrequest/addotherrequest.component';
import { ShorttermpayComponent } from './components/shorttermpay/shorttermpay.component';
import { AddshorttermpayComponent } from './components/shorttermpay/addshorttermpay/addshorttermpay.component';
import { EmpdetailschangeComponent } from './components/empdetailschange/empdetailschange.component';
import { AddempdetailschangeComponent } from './components/empdetailschange/addempdetailschange/addempdetailschange.component';
import { InsurancetypeComponent } from './components/insurancetype/insurancetype.component';
import { AddinsurancetypeComponent } from './components/insurancetype/addinsurancetype/addinsurancetype.component';
import { InsurancecompanyComponent } from './components/insurancecompany/insurancecompany.component';
import { AddinsurancecompanyComponent } from './components/insurancecompany/addinsurancecompany/addinsurancecompany.component';
import { ReasonComponent } from './components/reason/reason.component';
import { AddreasonComponent } from './components/reason/addreason/addreason.component';
import { InsuranceComponent } from './components/insurance/insurance.component';
import { AirticketComponent } from './components/airticket/airticket.component';
import { AddairticketComponent } from './components/airticket/addairticket/addairticket.component';
import { InsurancereportComponent } from './components/reports/insurancereport/insurancereport.component';
import { FinalsettlementComponent } from './components/finalsettlement/finalsettlement.component';
import { AddfinalsettlementComponent } from './components/finalsettlement/addfinalsettlement/addfinalsettlement.component';
import { AttendancereportComponent } from './components/reports/attendancereport/attendancereport.component';
import { AttendanceComponent } from './components/attendance/attendance.component';
import { AttendancesummaryreportComponent } from './components/reports/attendancesummaryreport/attendancesummaryreport.component';
import { CommonModule } from '@angular/common';
import { EmpreqdetailsreportComponent } from './components/reports/empreqdetailsreport/empreqdetailsreport.component';
import { EmppersonalreportComponent } from './components/reports/emppersonalreport/emppersonalreport.component';
import { HeadcountreportComponent } from './components/reports/headcountreport/headcountreport.component';
import { FinalsettlementreportComponent } from './components/reports/finalsettlementreport/finalsettlementreport.component';
import { HolidaysreportComponent } from './components/reports/holidaysreport/holidaysreport.component';
import { InoutpunchdetailsreportComponent } from './components/reports/inoutpunchdetailsreport/inoutpunchdetailsreport.component';
import { InoutpunchreportComponent } from './components/reports/inoutpunchreport/inoutpunchreport.component';
import { PaymentlistviewreportComponent } from './components/reports/paymentlistviewreport/paymentlistviewreport.component';
import { BulkbonusComponent } from './components/bonus/bulkbonus/bulkbonus.component';
import { AddbulkempdetailschangeComponent } from './components/empdetailschange/addbulkempdetailschange/addbulkempdetailschange.component';

const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'Dashboard', component: DashboardComponent },
  { path: 'Test', component: TestComponent },
  { path: 'Company', component: CompanyComponent },
  { path: 'AddCompany', component: AddcompanyComponent },
  { path: 'Branch', component: BranchComponent },
  { path: 'AddBranch', component: AddbranchComponent },
  { path: 'Allowance', component: AllowanceComponent },
  { path: 'AddAllowance', component: AddallowanceComponent },
  { path: 'AssetType', component: AssettypeComponent },
  { path: 'AddAssetType', component: AddassettypeComponent },
  { path: 'BonusType', component: BonustypeComponent },
  { path: 'AddBonusType', component: AddbonustypeComponent },
  { path: 'Department', component: DepartmentComponent },
  { path: 'AddDepartment', component: AdddepartmentComponent },
  { path: 'Deduction', component: DeductionComponent },
  { path: 'AddDeduction', component: AdddeductionComponent },
  { path: 'Designation', component: DesignationComponent },
  { path: 'AddDesignation', component: AdddesignationComponent },
  { path: 'EmpType', component: EmptypeComponent },
  { path: 'AddEmpType', component: AddemptypeComponent },
  { path: 'ExpenseType', component: ExpensetypeComponent },
  { path: 'AddExpenseType', component: AddexpensetypeComponent },
  { path: 'Gender', component: GenderComponent },
  { path: 'AddGender', component: AddgenderComponent },
  { path: 'Grade', component: GradeComponent },
  { path: 'AddGrade', component: AddgradeComponent },
  { path: 'IncidentType', component: IncidenttypeComponent },
  { path: 'AddIncidentType', component: AddincidenttypeComponent },
  { path: 'LeaveType', component: LeavetypeComponent },
  { path: 'AddLeaveType', component: AddleavetypeComponent },
  { path: 'LoanType', component: LoantypeComponent },
  { path: 'AddLoanType', component: AddloantypeComponent },
  { path: 'Location', component: LocationComponent },
  { path: 'AddLocation', component: AddlocationComponent },
  { path: 'MaritalStatus', component: MaritalstatusComponent },
  { path: 'AddMaritalStatus', component: AddmaritalstatusComponent },
  { path: 'MemoType', component: MemotypeComponent },
  { path: 'AddMemoType', component: AddmemotypeComponent },
  { path: 'OverTimeType', component: OvertimetypeComponent },
  { path: 'AddOverTimeType', component: AddovertimetypeComponent },
  { path: 'PayMode', component: PaymodeComponent },
  { path: 'AddPayMode', component: AddpaymodeComponent },
  { path: 'Payrollgrp', component: PayrolegrpComponent },
  { path: 'AddPayrollgrp', component: AddpayrolegrpComponent },
  { path: 'ReimburseType', component: ReimbursetypeComponent },
  { path: 'AddReimburseType', component: AddreimbursetypeComponent },
  { path: 'Relationship', component: RelationshipComponent },
  { path: 'AddRelationship', component: AddrelationshipComponent },
  { path: 'RelieveType', component: RelievetypeComponent },
  { path: 'AddRelieveType', component: AddrelievetypeComponent },
  { path: 'Skills', component: SkillsComponent },
  { path: 'AddSkills', component: AddskillsComponent },
  { path: 'UserRole', component: UserroleComponent },
  { path: 'AddUserRole', component: AdduserroleComponent },
  { path: 'User', component: UserComponent },
  { path: 'AddUser', component: AdduserComponent },
  { path: 'Asset', component: AssetComponent },
  { path: 'AddAsset', component: AddassetComponent },
  { path: 'Holidays', component: HolidaysComponent },
  { path: 'AddHolidays', component: AddholidaysComponent },
  { path: 'Emp', component: EmpComponent },
  { path: 'AddEmp', component: AddempComponent, canDeactivate: [PendingChangesGuard] },//
  { path: 'AddEmpNew', component: AddempnewComponent, canDeactivate: [PendingChangesGuard] },//
  { path: 'EmpView', component: AddempviewComponent, canDeactivate: [PendingChangesGuard] },//
  { path: 'Expense', component: ExpenseComponent },
  { path: 'AddExpense', component: AddexpenseComponent },
  { path: 'Leave', component: LeaveComponent },
  { path: 'AddLeave', component: AddleaveComponent },
  { path: 'Incident', component: IncidentComponent },
  { path: 'AddIncident', component: AddincidentComponent },
  { path: 'Religion', component: ReligionComponent },
  { path: 'AddReligion', component: AddreligionComponent },
  { path: 'Sponser', component: SponserComponent },
  { path: 'AddSponser', component: AddsponserComponent },
  { path: 'ContractType', component: ContracttypeComponent },
  { path: 'AddContractType', component: AddcontracttypeComponent },
  { path: 'Category', component: CategoryComponent },
  { path: 'AddCategory', component: AddcategoryComponent },
  { path: 'PayType', component: PaytypeComponent },
  { path: 'AddPayType', component: AddpaytypeComponent },
  { path: 'WpsGroup', component: WpsgroupComponent },
  { path: 'AddWpsGroup', component: AddwpsgroupComponent },
  { path: 'Bank', component: BankComponent },
  { path: 'AddBank', component: AddbankComponent },
  { path: 'Status', component: StatusComponent },
  { path: 'AddStatus', component: AddstatusComponent },
  { path: 'LeavePolicy', component: LeavepolicyComponent },
  { path: 'AddLeavePolicy', component: AddleavepolicyComponent },
  { path: 'HiResource', component: HiresourceComponent },
  { path: 'AddHiResource', component: AddhiresourceComponent },
  { path: 'Salution', component: SalutionComponent },
  { path: 'AddSalution', component: AddsalutionComponent },
  { path: 'AccomType', component: AccomtypeComponent },
  { path: 'AddAccomType', component: AddaccomtypeComponent },
  { path: 'DocType', component: DoctypeComponent },
  { path: 'AddDocType', component: AdddoctypeComponent },
  { path: 'Login', component: LoginComponent },
  { path: 'Jinna', component: DepartmentComponent },
  { path: 'Bonus', component: BonusComponent },
  { path: 'AddBonus', component: AddBonusComponent },
  { path: 'AddBulkBonus', component: BulkbonusComponent },
  { path: 'Reimburse', component: ReimburseComponent },
  { path: 'AddReimburse', component: AddreimburseComponent },
  { path: 'Memo', component: MemoComponent },
  { path: 'AddMemo', component: AddmemoComponent },
  { path: 'Training', component: TrainingComponent },
  { path: 'AddTraining', component: AddtrainingComponent },
  { path: 'Payadv', component: PayadvComponent },
  { path: 'AddPayadv', component: AddpayadvComponent },
  { path: 'Transfer', component: TransferComponent },
  { path: 'AddTransfer', component: AddtransferComponent },
  { path: 'Overtime', component: OvertimeComponent },
  { path: 'AddOvertime', component: AddovertimeComponent },
  { path: 'Loan', component: LoanComponent },
  { path: 'AddLoan', component: AddloanComponent },
  { path: 'Payroll', component: PayrollComponent },
  { path: 'AddPayroll', component: AddpayrollComponent },
  { path: 'Annualleave', component: AnnualleaveComponent },
  { path: 'AddAnnualleave', component: AddannualleaveComponent },
  { path: 'Leavesalary', component: LeavesalaryComponent },
  { path: 'AddLeavesalary', component: AddleavesalaryComponent },
  { path: 'Payadj', component: PayadjComponent },
  { path: 'AddPayadj', component: AddpayadjComponent },
  { path: 'Approvals', component: ApprovalsComponent },
  { path: 'Reports', component: ReportsComponent },
  { path: 'Reports/:reportname', component: ReportsummaryComponent },
  { path: 'Bankbranch', component: BankbranchComponent },
  { path: 'AddBankbranch', component: AddbankbranchComponent },
  { path: 'Alerttype', component: AlerttypeComponent },
  { path: 'AddAlerttype', component: AddalerttypeComponent },
  { path: 'Settings', component: SettingsComponent },
  { path: 'Currency', component: CurrencyComponent },
  { path: 'AddCurrency', component: AddcurrencyComponent },
  { path: 'ExpensePolicy', component: ExpensepolicyComponent },
  { path: 'AddExpensePolicy', component: AddexpensepolicyComponent },
  { path: 'ScheduleTemplate', component: ScheduletemplateComponent },
  { path: 'AddScheduleTemplate', component: AddscheduletemplateComponent },
  { path: 'ProfessionalTax', component: PtaxmainComponent },
  { path: 'AddProfessionalTax', component: AddptaxmainComponent },
  { path: 'EmployeeSummaryReport', component: ReportemployeesummaryComponent },
  { path: 'ActivitylogReport', component: ActivitylogreportComponent },
  { path: 'LeaveReport', component: LeavereportComponent },
  { path: 'AssetReport', component: AssetreportComponent },
  { path: 'TrainingReport', component: TrainingreportComponent },
  { path: 'OvertimeReport', component: OvertimereportComponent },
  { path: 'PayrollSummaryReport', component: PayrollsummaryreportComponent },
  { path: 'EmployeePayReport', component: EmployeepayreportComponent },
  { path: 'PayadvReport', component: PayadvreportComponent },
  { path: 'SettingsMenu', component: NavigationmenuComponent },
  { path: 'TransPaymode', component: TranspaymodeComponent },
  { path: 'AddTransPaymode', component: AddtranspaymodeComponent },
  { path: 'FineType', component: FinetypeComponent },
  { path: 'AddFineType', component: AddfinetypeComponent },
  { path: 'Fine', component: FineComponent },
  { path: 'AddFine', component: AddfineComponent },
  { path: 'Promotion', component: PromotionComponent },
  { path: 'AddPromotion', component: AddpromotionComponent },
  { path: 'DocumentExpiryReport', component: DocumentexpiryreportComponent },
  { path: 'EmployeeSalaryReport', component: EmployeesalaryreportComponent },
  { path: 'LoanSummaryReport', component: LoansummaryreportComponent },
  { path: 'LoanOutstandingSummaryReport', component: LoanoutstandingsummaryreportComponent },
  { path: 'Calendarview', component: CalendarviewComponent },
  { path: 'RequestType', component: RequesttypeComponent },
  { path: 'AddRequestType', component: AddrequesttypeComponent },
  { path: 'OtherRequest', component: OtherrequestComponent },
  { path: 'AddOtherRequest', component: AddotherrequestComponent },
  { path: 'EmpDetailsChange', component: EmpdetailschangeComponent },
  { path: 'AddEmpDetailsChange', component: AddempdetailschangeComponent },
  { path: 'AddBulkEmpDetailsChange', component: AddbulkempdetailschangeComponent },
  { path: 'ShorttermPay', component: ShorttermpayComponent },
  { path: 'AddShorttermPay', component: AddshorttermpayComponent },
  { path: 'InsuranceType', component: InsurancetypeComponent },
  { path: 'AddInsuranceType', component: AddinsurancetypeComponent },
  { path: 'InsuranceCompany', component: InsurancecompanyComponent },
  { path: 'AddInsuranceCompany', component: AddinsurancecompanyComponent },
  { path: 'Reason', component: ReasonComponent },
  { path: 'AddReason', component: AddreasonComponent },
  { path: 'Insurance', component: InsuranceComponent },
  { path: 'Airticket', component: AirticketComponent },
  { path: 'AddAirticket', component: AddairticketComponent },
  { path: 'InsuranceReport', component: InsurancereportComponent },
  { path: 'FinalSettlement', component: FinalsettlementComponent },
  { path: 'AddFinalSettlement', component: AddfinalsettlementComponent },
  { path: 'AttendanceReport', component: AttendancereportComponent },
  { path: 'AttendanceSummaryReport', component: AttendancesummaryreportComponent },
  { path: 'Attendance', component: AttendanceComponent },
  { path: 'EmpReqDetailsReport', component: EmpreqdetailsreportComponent },
  { path: 'EmpPersonalDetailsReport', component: EmppersonalreportComponent },
  { path: 'HeadCountReport', component: HeadcountreportComponent },
  { path: 'FinalSettlementReport', component: FinalsettlementreportComponent },
  { path: 'HolidaysReport', component: HolidaysreportComponent },
  { path: 'InoutPunchDetailsReport', component: InoutpunchdetailsreportComponent },
  { path: 'InoutPunchReport', component: InoutpunchreportComponent },
  { path: 'PaymentListviewReport', component: PaymentlistviewreportComponent },

];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false }), CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
